<template lang="">
  <div class="pb-4 full-width" v-if="fields && fields.length > 0">
    <div> Trường dữ liệu con</div>
    <v-row v-for="field in fields" :key="field.code" no-gutters>
      <v-col cols="6">
        <field-group
          v-model="field.name"
          filled
          label="Tên"
          no-label
          hide-details
        ></field-group>
      </v-col>
      <v-col cols="6">
        <v-switch
          class="pl-4"
          v-model="field.visibility['browse']"
          inset
          label="Hiển thị"
        ></v-switch>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
  },
  computed: {
    fields() {
      return this.value.field.fields
    },
    form: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
<style lang=""></style>
